// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer_Footer__T3lDs","Footer__wrapper":"footer_Footer__wrapper__O2_nL"};